/**
 * WarenausgangPaketPDF — Kommissionierung anında inen TEK çok sayfalı PDF.
 *
 * Sayfa 1: Kommissionierschein (resim + Lagerort + Menge + OK)
 * Sayfa 2: Lieferschein — Lager nüshası (Lagerort sütunlu)
 * Sayfa 3: Lieferschein — Kunde nüshası
 *
 * Tek dosya iner (KM-YYYY-NNNN_Paket.pdf); tek tek belgeler karttaki
 * "Dokumente" düğmelerinden ayrıca indirilebilir.
 */
import { fetchPdfSettings, downloadPdfFromHtml, wrapPdfDocument } from '@/lib/pdfRenderer';
import { buildKommissionierscheinBody } from './KommissionierscheinPDF';
import { buildLieferscheinBody } from './LieferscheinPDF';

export async function downloadWarenausgangPaket(order, products = [], customSettings) {
  const settings = customSettings || await fetchPdfSettings();

  const km = buildKommissionierscheinBody(order, settings, products);
  const lsLager = buildLieferscheinBody(order, settings, { exemplar: 'Lager', products });
  const lsKunde = buildLieferscheinBody(order, settings, { exemplar: 'Kunde', products });

  const combined = `
    <div>${km}</div>
    <div style="page-break-before:always;padding-top:28px">${lsLager}</div>
    <div style="page-break-before:always;padding-top:28px">${lsKunde}</div>
  `;

  const html = wrapPdfDocument(
    combined,
    `Warenausgang ${order.picking_number || order.order_number || ''}`
  );
  const fileName = `${order.picking_number || `KM-${Date.now()}`}_Paket`;
  await downloadPdfFromHtml(html, fileName);
}

export default { downloadWarenausgangPaket };
